var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessman3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M312.533,296.478v-85.333c7.467-14.933,11.733-54.4,11.733-54.4V58.612l-72.533-35.2L192,59.678 l-18.133,43.733l12.8,77.867c0,0,4.267,28.8,13.867,42.667v82.133L312.533,296.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M312.533,211.145v35.2l0,0c9.6,14.933,7.467,74.667,7.467,123.733H181.333 c4.267-50.133,7.467-104.533,18.133-123.733l0,0v-24.533c-8.533-13.867-13.867-42.667-13.867-42.667l-12.8-77.867l18.133-43.733 l59.733-36.267l72.533,35.2v98.133C324.267,156.745,320,196.212,312.533,211.145z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EAE9"
    },
    d: "M331.733,511.945L320,309.278h-1.067c-9.6,24.533-34.133,42.667-62.933,42.667 s-53.333-18.133-62.933-42.667H192l-11.733,202.667H331.733z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.24 -0.9708 0.9708 0.24 102.0007 431.1546)",
    style: {
      fill: "#FFD15C"
    },
    cx: 326.362,
    cy: 150.433,
    rx: 29.867,
    ry: 13.867
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.24 0.9708 -0.9708 0.24 290.0231 -57.513)",
    style: {
      fill: "#FFD15C"
    },
    cx: 181.743,
    cy: 156.47,
    rx: 29.867,
    ry: 13.867
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M179.2,150.345c1.067,4.267,3.2,13.867,5.333,18.133h3.2c-1.067-4.267-2.133-13.867-2.133-19.2 c1.067-8.533-2.133-22.4,3.2-30.933c4.267-8.533-1.067-21.333,0-25.6c1.067-5.333-4.267-13.867,24.533-25.6s92.8-29.867,97.067,28.8 c0,0-2.133,7.467,2.133,13.867c4.267,6.4,6.4,14.933,7.467,23.467c0,7.467,0,27.733,0,36.267h4.267c2.133-3.2,2.133-22.4,8.533-38.4 c5.333-13.867,8.533-27.733,9.6-42.667c5.333-45.867-48-96-97.067-87.467c-49.067,9.6-71.467,41.6-74.667,59.733 c-3.2,17.067-2.133,48,0,59.733C171.733,131.145,177.067,143.945,179.2,150.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B64C"
    },
    d: "M248.533,262.345c-30.933,0-49.067-38.4-49.067-38.4v23.467l0,0c-6.4,10.667-9.6,29.867-12.8,53.333 c12.8-3.2,38.4-6.4,50.133-10.667c62.933-23.467,74.667-78.933,74.667-78.933l0,0l0,0l0,0 C312.533,211.145,288,262.345,248.533,262.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344A5E"
    },
    d: "M0,511.945h235.733l-1.067-7.467l-59.733-218.667L64,310.345 c-19.2,5.333-33.067,20.267-37.333,39.467C18.133,391.412,0,502.345,0,511.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M199.467,247.412L199.467,247.412l-60.8,59.733l35.2,13.867l-43.733,21.333l90.667,169.6H240 l-39.467-211.2C196.267,282.612,196.267,264.478,199.467,247.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344A5E"
    },
    d: "M512,511.945H276.267l1.067-7.467l59.733-218.667L448,310.345 c19.2,5.333,33.067,20.267,37.333,39.467C493.867,391.412,512,502.345,512,511.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M312.533,247.412L312.533,247.412l60.8,60.8l-32,13.867l39.467,21.333l-89.6,168.533H272 l39.467-211.2C315.733,282.612,315.733,264.478,312.533,247.412z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessman3);
export default __webpack_public_path__ + "static/media/businessman_3.b04b45d1c3425396db10e403737b5c41.svg";
export { ForwardRef as ReactComponent };